import * as _ from 'lodash';
import { ContentScores } from './contentScores';
import { trimAllStringsInObject, normalizeSectionId, } from './services/contentNormalizer';
import { interpolateSingleValue } from './contentInterpolator';
import { CeField } from './enums/CeFiled';
var ContentMapCreator = /** @class */ (function () {
    function ContentMapCreator(flags) {
        this.settings = {};
        this.replacementsWithDefaults = {};
        this.replacementsWithPlaceholders = {};
        this.flags = flags !== null && flags !== void 0 ? flags : {};
    }
    ContentMapCreator.prototype.createMap = function (settings) {
        this.settings = settings;
        trimAllStringsInObject(this.settings.contentItems);
        this.initReplacements();
        return this.sortMapByScore(this.initMap());
    };
    ContentMapCreator.prototype.initMap = function () {
        var _this = this;
        var contentMap = {};
        contentMap[ContentMapCreator.DefaultSectionKey] = {};
        if (!this.settings.contentItems) {
            return contentMap;
        }
        this.settings.contentItems.forEach(function (currentValue) {
            var hasSectionIds = currentValue.sectionIds &&
                currentValue.sectionIds.length > 0 &&
                currentValue.sectionIds &&
                currentValue.sectionIds[0] !== ContentMapCreator.DefaultSectionKey;
            if (hasSectionIds) {
                _.forEach(currentValue.sectionIds, function (sectionId) {
                    sectionId = normalizeSectionId(sectionId);
                    if (!_.has(contentMap, sectionId)) {
                        contentMap[sectionId] = {};
                    }
                    var currentItemByType = contentMap[sectionId];
                    var scoreMultiple = _this.calculateItemSignatureScore(currentValue);
                    _this.addContent(currentItemByType, currentValue, scoreMultiple);
                });
            }
            else {
                // no section, apply to default key
                var score = _this.calculateItemSignatureScore(currentValue, true);
                var defaultContentItem = contentMap[ContentMapCreator.DefaultSectionKey];
                _this.addContent(defaultContentItem, currentValue, score);
            }
        });
        return contentMap;
    };
    ContentMapCreator.prototype.calculateItemSignatureScore = function (contentItem, isDefaultContent) {
        if (isDefaultContent === void 0) { isDefaultContent = false; }
        var hasStructureSignature = contentItem.structureIds && contentItem.structureIds.length > 0;
        var hasIndustrySignature = contentItem.industryIds && contentItem.industryIds.length > 0;
        if (isDefaultContent) {
            return this.scoreDefaultContent(contentItem);
        }
        if (hasStructureSignature && hasIndustrySignature) {
            return ContentScores.scoreForFullSignature;
        }
        if (hasStructureSignature && !hasIndustrySignature) {
            return ContentScores.scoreForNoIndustrySignature;
        }
        if (!hasStructureSignature && hasIndustrySignature) {
            return ContentScores.scoreForNoStructureSignature;
        }
        return ContentScores.scoreForNoStructureAndIndustrySignature;
    };
    ContentMapCreator.prototype.scoreDefaultContent = function (contentItem) {
        var hasIndustrySignature = contentItem.industryIds && contentItem.industryIds.length > 0;
        var hasStructureSignature = contentItem.structureIds && contentItem.structureIds.length > 0;
        var isSpecificIndustry = hasIndustrySignature &&
            _.includes(contentItem.industryIds, this.settings.industryId);
        if (hasIndustrySignature) {
            return isSpecificIndustry
                ? ContentScores.scoreForDefaultSpecificIndustry
                : ContentScores.scoreForDefaultIndustry;
        }
        if (this.flags.enableNewScoreForDefaultContent) {
            if (hasStructureSignature) {
                return ContentScores.scoreForDefaultStructure;
            }
        }
        return ContentScores.scoreForDefaultContent;
    };
    ContentMapCreator.prototype.addContent = function (contentMapItem, contentItem, scoreMultiple) {
        var _this = this;
        var contentOffsetByField = {};
        _.forEach(contentItem.content, function (contentItemsArray, ciField) {
            if (contentItemsArray && contentItemsArray.length > 0) {
                // remember the content offset that was added for each field
                var existingFieldContent = contentMapItem[ciField] || [];
                contentOffsetByField[ciField] = existingFieldContent.length;
                var setOfExistingContent_1 = createSetFromContent(existingFieldContent, ciField);
                var newContent = contentItemsArray
                    .map(function (val) {
                    var rankedItem = interpolateSingleValue(val, // tslint:disable-line no-non-null-assertion
                    _this.settings.replacements, _this.replacementsWithPlaceholders, _this.replacementsWithDefaults);
                    rankedItem.score *= scoreMultiple;
                    return rankedItem;
                })
                    .filter(function (it) {
                    if (ciField === CeField.image) {
                        // remove images that is not in current geo
                        it.content = it.content.filter(function (media) {
                            // if there is no geo, add 'all' as default and do not remove it
                            if (!media.geo || media.geo.length === 0) {
                                media.geo = ['all'];
                                return true;
                            }
                            var geoSet = new Set(media.geo);
                            return geoSet.has(_this.settings.geo) || geoSet.has('all');
                        });
                        return true;
                    }
                    // do not remove items with sets
                    if (contentItem.sets && contentItem.sets.length > 0) {
                        return true;
                    }
                    // remove items that already exist in content map
                    return !setOfExistingContent_1.has(it.content);
                });
                // add a new content to map only if it doesn't exist
                if (newContent.length > 0) {
                    contentMapItem[ciField] = existingFieldContent.concat(newContent);
                }
            }
        });
        this.buildSets(contentItem.sets, contentMapItem, contentOffsetByField);
    };
    ContentMapCreator.prototype.buildSets = function (sets, contentMapItem, contentOffsetByField) {
        _.forEach(sets, function (set) {
            var setItems = _.map(set, function (index, ceField) { return ({
                field: ceField,
                index: index + contentOffsetByField[ceField],
            }); });
            // reference the correct set for each content item that participates in that set
            _.forEach(setItems, function (setItem) {
                var contentMapEntry = contentMapItem[setItem.field][setItem.index];
                contentMapEntry.setItems = setItems;
            });
        });
    };
    ContentMapCreator.prototype.sortMapByScore = function (contentMap) {
        return _.mapValues(contentMap, function (itemByField) {
            return _.mapValues(itemByField, function (arr) {
                return _.sortBy(arr, function (item) { return item.isFinal && -item.score; });
            });
        });
    };
    ContentMapCreator.prototype.initReplacements = function () {
        var placeholderReplacements = this.createPlaceholderReplacements();
        this.replacementsWithPlaceholders = _.merge({}, placeholderReplacements, this.settings.replacements);
        this.replacementsWithDefaults = _.merge({}, this.settings.defaultReplacements, placeholderReplacements, this.settings.replacements);
    };
    ContentMapCreator.prototype.createPlaceholderReplacements = function () {
        var _this = this;
        if (!this.settings.placeholders) {
            return {};
        }
        var replacements = {};
        _.forEach(this.settings.placeholders, function (placeholder) {
            var specificStructureValue = placeholder.structureId &&
                placeholder.structureId === _this.settings.structureId;
            var firstTimeValue = !placeholder.structureId && !_.has(replacements, placeholder.name);
            if (firstTimeValue || specificStructureValue) {
                _.set(replacements, placeholder.name, placeholder.default); // key for tokens
                _.set(replacements, "placeholder." + placeholder.name, placeholder.default);
                // setup key for defaults
                if (placeholder.value && !placeholder.value.startsWith('self.')) {
                    _.set(replacements, placeholder.value, placeholder.default); // set default value for stage tokens
                }
            }
        });
        return replacements;
    };
    ContentMapCreator.DefaultSectionKey = '#DEFAULT#';
    return ContentMapCreator;
}());
export { ContentMapCreator };
function createSetFromContent(contentData, ciField) {
    var array;
    if (ciField === 'image') {
        // handle images/video/shapes
        array = _.flatMap(contentData, function (it) { return it.content; })
            .map(function (it) {
            if ('fileUrl' in it || 'videoUrl' in it) {
                return it.fileUrl || it.videoUrl;
            }
            return '';
        })
            .filter(function (it) { return !!it; });
    }
    else {
        array = contentData.map(function (it) { return it.content; });
    }
    return new Set(array);
}
//# sourceMappingURL=contentMapCreator.js.map